import { MOBILE_MAX_WIDTH } from '@/app/utils/constants';
import { useMediaQuery } from 'react-responsive';

export function useMobile() {
    return useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });
}
